(function () {
    "use strict";

    angular
        .module('harriApp')
        .controller("ManageTagsModalController", ManageTagsModalController);

    ManageTagsModalController.$inject = ["$scope", "modalData", "tagsDataService", "onClose"];

    function ManageTagsModalController ($scope, modalData, tagsDataService, onClose) {
        const self = this;
        let originalTags = [];

        let init = () => {
            self.tags = modalData.tags;
            self.tagsType = modalData.tagsType;
            self.brandId = modalData.brandId;
            originalTags = angular.copy(self.tags);
            setTimeout(() => {
                handleDrag();
            }, 1);
        }

        const handleDrag = () => {
            let elm = $(".manage-tags-modal");
            let draggedElmId;

            elm.on("dragstart", (event) => {
                draggedElmId = $(event.target).attr("id");
            });

            elm.on("dragend", (event) => {
                draggedElmId = null;
                self.dragOverIndex = null;
            });

            elm.on("dragover", ".tag-item", (event) => {
                let tagItem = $(event.originalEvent.target);
                if (!tagItem.hasClass("tag-item")) {
                    tagItem = tagItem.parents(".tag-item");
                }

                if (tagItem.attr("id") != draggedElmId) {
                    self.dragOverIndex = parseInt(tagItem.attr("id"));
                } else {
                    self.dragOverIndex = null;
                }
                event.preventDefault();
            });

            elm.on("drop", ".tag-item", (event) => {
                let tagItem = $(event.originalEvent.target);

                if (!tagItem.hasClass("tag-item")) {
                    tagItem = tagItem.parents(".tag-item");
                }

                if (tagItem.attr("id") != draggedElmId) {
                    moveTag(parseInt(draggedElmId), parseInt(tagItem.attr("id")));
                    draggedElmId = null;
                    self.dragOverIndex = null;
                    $scope.$digest();
                }
                event.preventDefault();
            });
        };

        const moveTag = (fromIndex, toIndex) => {
            let tags = angular.copy(self.tags[fromIndex]);
            self.tags[fromIndex].delete = true;

            if (toIndex >= fromIndex) {
                self.tags.splice(toIndex + 1, 0, tags);
            } else {
                self.tags.splice(toIndex, 0, tags);
            }

            for (const i in self.tags) {
                if (self.tags[i].delete) {
                    self.tags.splice(i, 1);
                    break;
                }
            }
        };

        init();

        self.close = () => {
            self.tags = angular.copy(originalTags);
            onClose?.(self.tags);
            $scope.$hide();
        };

        self.save = async () => {
            self.isLoading = true;
            const payload = self.tags.map((tag, index) => ({
                brand_tag_id: tag.id,
                sort_order: index + 1
            }));

            try {
                const res = await tagsDataService.manageTagsOrder(self.brandId, self.tagsType, payload);
                $scope.$hide();
                return res;
            } catch (err) {
                console.log(err);
                throw err;
            } finally {
                self.isLoading = false;
                $scope.$digest();
            }
        };
    }
})();
